import React, { useEffect, useState } from 'react'

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
// import { getVersion } from '../services/getVersion';
import { useLocation } from 'react-router-dom';
// import logojc from '../media/JC.png'

export const Footer = () => {

    const location = useLocation();

    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------IMPORTANTE CAMBIAR LA VERSION AQUI Y EN LA TABLA version EN LA BBDD-----------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    const [versionLocal, setVersionLocal] = useState('1.2.0'); //---------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------

    const [actualizado, setActualizado] = useState(false);

    const comprobarVersion = async (versionLocal) => {
        // console.log("Comprobando versión local:", versionLocal);

        // try {
        //     const response = await getVersion(versionLocal);

        //     // console.log("Respuesta del servidor:", response);

        //     if (response.success && response.actualizar) {
        //         if (!actualizado) {
        //             setActualizado(true);
        //             actualizarApp();
        //         }
        //     }

        // } catch (error) {
        //     console.error("Error:", error);
        // }
    }

    const actualizarApp = () => {
        // Paso 1: Enviar headers anti-caché (opcional)
        fetch(window.location.href, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        }).then(() => {
            // Paso 2: Recargar la página con un parámetro único
            window.location.href = window.location.href.split('?')[0] + '?updateApp=' + Date.now();
        });
    };

    useEffect(() => {
        comprobarVersion(versionLocal);
    }, [location.pathname]);


    return (
        <Grid
            container
            direction="column"
            justifyContent="end"
            alignItems="center"
            xs={12}
            sx={{ mb: 2 }}
            className='no-select'
        >
            {/* <Typography variant='caption' style={{ textAlign: 'center' }}>
                Powered by JC Informatics ©
            </Typography> */}
            {/* <Grid container xs={3} md={2} xl={1.5}>
                <img src={logojc} alt="" style={{width: '100%'}}/>
            </Grid> */}

            <Typography variant='caption' className='texto-gris' style={{ textAlign: 'center' }}>
                v{versionLocal}
            </Typography>
        </Grid>
    )
}
